module.exports = __webpack_public_path__ + "static/img/sig553.d2c726e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/sig553.png
// module id = 3gCC
// module chunks = 0